var map = {
	"./border_collie.svg": 935,
	"./chihuahua.svg": 3254,
	"./dog-background.svg": 3944,
	"./duo.svg": 5737,
	"./golden_retriever.svg": 3220,
	"./great_dane.svg": 8649,
	"./group.svg": 6787,
	"./solo.svg": 5751,
	"./st_bernard.svg": 9775
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8194;